import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import prof from "../../img/prof default.png";
import moment from "moment";
const NotesDisplay = ({ video, small, coll }) => {
  return (
    <Link to={`/${coll}/notes/${video.id}`} className='card-link nolinklook'>
      {video && (
        <div className='card mb-3 bg-light'>
          <div className='row no-gutters'>
            <div className='col-md-3'>
              <h5 className='fontcool text-center size09'>
                <br></br>
                {video.resourcetype}
              </h5>
            </div>

            <div className='col-md-9'>
              <div className='card-header'>
                <h5 className='card-title fontcool'>{video.name}</h5>
                {small !== "no" && <strong>{video.author}</strong>}
              </div>
              {small === "no" && (
                <div className='card-body'>
                  <p className='card-text simplefont'>
                    {video.subject && (
                      <span className='badge badge-secondary'>
                        Subject: {video.subject}
                      </span>
                    )}{" "}
                    {video.branch && (
                      <span className='badge badge-secondary'>
                        Branch: {video.branch}
                      </span>
                    )}{" "}
                    {video.course && (
                      <span className='badge badge-secondary'>
                        Course: {video.course}
                      </span>
                    )}{" "}
                    {video.year && (
                      <span className='badge badge-secondary'>
                        Year: {video.year}
                      </span>
                    )}
                  </p>
                  <p>
                    <span className='blue-grey-text text-lighten-2'>
                      {moment(video.date.toDate()).format(
                        "MMMM Do YYYY, HH:MM"
                      )}{" "}
                    </span>
                  </p>
                  <p className='card-text simplefont'>
                    <small className='text-muted'>
                      {video.description && video.description}
                    </small>
                  </p>
                  <h6 className='card-subtitle mb-2 text-muted slantfont text-right'>
                    By: {video.author}
                  </h6>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Link>
  );
};

const VideoDisplay = ({ video, small, coll }) => {
  return (
    <Link to={`/${coll}/video/${video.id}`} className='card-link nolinklook'>
      {video && (
        <div className='card mb-3 bg-light'>
          <div className='row no-gutters'>
            <div className='col-md-3'>
              {video.url && video.url.length > 30 ? (
                <div>Awaiting approval</div>
              ) : (
                <img
                  src={`https://img.youtube.com/vi/${video.url}/0.jpg`}
                  className='card-img'
                  alt='...'
                />
              )}
            </div>

            <div className='col-md-9'>
              <div className='card-header'>
                <h5 className='card-title fontcool'>{video.name}</h5>
                {small !== "no" && <strong>{video.author}</strong>}
              </div>
              {small === "no" && (
                <div className='card-body'>
                  <p className='card-text simplefont'>
                    {video.subject && (
                      <span className='badge badge-secondary'>
                        Subject: {video.subject}
                      </span>
                    )}{" "}
                    {video.branch && (
                      <span className='badge badge-secondary'>
                        Branch: {video.branch}
                      </span>
                    )}{" "}
                    {video.course && (
                      <span className='badge badge-secondary'>
                        Course: {video.course}
                      </span>
                    )}{" "}
                    {video.year && (
                      <span className='badge badge-secondary'>
                        Year: {video.year}
                      </span>
                    )}
                  </p>
                  <p>
                    <span className='blue-grey-text text-lighten-2'>
                      {video.date &&
                        moment(video.date.toDate()).format(
                          "MMMM Do YYYY, HH:MM"
                        )}{" "}
                    </span>
                  </p>
                  <p className='card-text simplefont'>
                    <small className='text-muted'>
                      {video.description && video.description}
                    </small>
                  </p>
                  <h6 className='card-subtitle mb-2 text-muted slantfont text-right'>
                    By: {video.author}
                  </h6>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Link>
  );
};

const ClassesDisplay = ({ video, small }) => {
  return (
    <Link
      to={`/acad/lec/${video.id}`}
      className='card-link nolinklook overflow-hidden'
    >
      {video && (
        <div className='card mb-3 bg-light'>
          <div className='row no-gutters'>
            <div className='col-md-3'>
              {small === "no" ? (
                <img src={prof} className='card-img' alt='...' />
              ) : (
                <p className='fontcool text-center'>
                  {video.subject}
                  <br></br>
                  <h5 className='badge badge-dark size09 badge-pill'>
                    {video.id.split("2020")[1]}
                  </h5>
                </p>
              )}
            </div>
            <div className='col-md-9'>
              {small === "no" ? (
                <div className='card-header'>
                  <h4 className='card-title fontcool'>
                    <h5 className='badge badge-dark badge-pill'>
                      {video.subject} Lecture {video.id.split("2020")[1]}
                    </h5>{" "}
                    {video.name}
                  </h4>
                </div>
              ) : (
                <div className='card-header'>
                  <h5 className='card-title fontcool'>{video.name}</h5>
                  <strong>{video.prof}</strong>
                </div>
              )}
              {small === "no" && (
                <div className='card-body'>
                  <p className='card-text simplefont'>
                    {video.branch && (
                      <span className='badge badge-secondary'>
                        Branch: {video.branch}
                      </span>
                    )}{" "}
                    {video.course && (
                      <span className='badge badge-secondary'>
                        Course: {video.course}
                      </span>
                    )}{" "}
                    {video.year && (
                      <span className='badge badge-secondary'>
                        Year: {video.year}
                      </span>
                    )}
                  </p>
                  <p>
                    <span className='blue-grey-text text-lighten-2'>
                      {video.date &&
                        moment(video.date.toDate()).format(
                          "MMMM Do YYYY, HH:MM"
                        )}{" "}
                    </span>
                  </p>
                  <p className='card-text simplefont'>
                    <small className='text-muted'>
                      {video.description && video.description}
                    </small>
                  </p>
                  <h6 className='card-subtitle mb-2 text-muted slantfont text-right'>
                    By: {video.prof}
                  </h6>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Link>
  );
};

const VideoItem = ({ video, small, coll, type, key }) => {
  return (
    <Fragment>
      {video.type === "notes" ? (
        <NotesDisplay video={video} small={small} coll={coll} />
      ) : video.type === "profs" ? (
        <ClassesDisplay video={video} small={small} />
      ) : (
        <VideoDisplay video={video} small={small} coll={coll} />
      )}
    </Fragment>
  );
};

export default VideoItem;
